import { createSimpleState } from '@@plate/serialization/creators/createSimpleState';
import { RichTextCodec } from '@@plate/serialization/unity';
import { type RootElement } from '@@plate/serialization/unity/groups';

const deserializeState = (serializedState: unknown): RootElement[] => {
    if (!serializedState) {
        return createSimpleState();
    }

    const deserialized = RichTextCodec.safeParse(serializedState);

    if (deserialized.success) {
        return deserialized.data;
    }

    console.error(deserialized.error.message, serializedState);
    throw new Error('Failed to decode richtext with Plate.js codec. Details in console.');
};

export default deserializeState;
